import { useCallback, useContext } from 'react';
import { SetBannerStateContext } from './../store';
export var useAddBanner = function () {
    var context = useContext(SetBannerStateContext);
    // $TODO: Uncomment when we either surround Edgeworth in Angular with a HarmonyProvider
    // or migrate to React
    // if (!context) {
    //     throw new Error(
    //         'SetBannerStateContext must be used within a BannerProvider',
    //     );
    // }
    var useAddBannerCallback = useCallback(function (banner) {
        context === null || context === void 0 ? void 0 : context.addBanner(banner);
    }, [context]);
    return useAddBannerCallback;
};
//# sourceMappingURL=useAddBanner.js.map